/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4cad5a4ce9de3d8f027113d1b7910c8>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const WhiteboardIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.178c-.714.282-1.28.816-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.169 8.61.783c.943-.373 2.248-.49 3.09.374.346.356.536.778.548 1.237.011.436-.14.827-.323 1.144-.228.393-.557.76-.876 1.074 1.466-.137 2.717.238 3.421 1.133.827 1.05.644 2.464-.256 3.698l-1.212-.885c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.756-2.524-.512-.521.09-.935.139-1.236.13a1.4 1.4 0 0 1-.537-.109.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.496 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.18.102-.179.124-.292.123-.355-.002-.04-.01-.112-.124-.23-.2-.204-.716-.32-1.464-.025M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
WhiteboardIcon.displayName = 'WhiteboardIcon';
var _default = exports.default = WhiteboardIcon;